import React, { useEffect, useState } from "react";
import _ from "underscore";
import Carousel from "react-bootstrap/Carousel";
import ReactHtmlParser from "react-html-parser";
import { getRewardsPlusDiscountThreshold } from "../../common/utils";
import Currency from "../../common/Currency";

const PromoMessages = ({promo_messages, productPrice}) => {
    const [copyDiscountCode, setCopyDiscountcode] = useState(false);
    const rewardsPlusPrice = getRewardsPlusDiscountThreshold(productPrice);

    const handleCopy = (discountCode) => {
        navigator.clipboard.writeText(discountCode);
        setCopyDiscountcode(true);

        setTimeout(() => {
            setCopyDiscountcode(false);
        }, 5000)
    }

    return (
        <Carousel
            interval={5000}
            controls={false}
            indicators={promo_messages && promo_messages.length > 1}
        >
            { _.map(promo_messages, (messageDetails, key) => {
                const discountPercentage = messageDetails.discount_percentage;
                const discountCode = messageDetails.discount_code;
                const discountedPrice = rewardsPlusPrice - rewardsPlusPrice * discountPercentage / 100;

                return (
                    <Carousel.Item key={key} className={`carousel-item ${discountCode && `carousel-item--code-${discountCode.toLowerCase()}`}`}>
                        {rewardsPlusPrice && discountedPrice && discountCode ?
                            <span>
                                Get it for as low as <Currency className="font-weight-bold" value={discountedPrice} /> with code <strong>{discountCode}</strong> at checkout.
                            </span>
                        :
                            <span>
                                {ReactHtmlParser(messageDetails.message)}
                            </span>
                        }
                        {/*{discountCode &&*/}
                        {/*    <Button*/}
                        {/*        variant="clean"*/}
                        {/*        className={`pdp__promo-messaging-copy-button ${copyDiscountCode ? "pdp__promo-messaging-copy-button--copied" : ""}`}*/}
                        {/*        onClick={() => {handleCopy(discountCode)}}*/}
                        {/*    >*/}
                        {/*        <span className="pdp__promo-messaging-copy-button-wrapper">*/}
                        {/*            <CopyIcon*/}
                        {/*                style={{width: 14}}*/}
                        {/*                className="pdp__promo-messaging-copy-icon"*/}
                        {/*                label="Copy Code"*/}
                        {/*                color="#2E2E3A"*/}
                        {/*            />*/}
                        {/*        </span>*/}
                        {/*    </Button>*/}
                        {/*}*/}
                    </Carousel.Item>
                )
            })}
        </Carousel>
    )
}

export default PromoMessages;